const ActivityCategory = {
  development: {
    loyaltyProgramClientTracking: {
      lookupItemId: 71856,
      lookupItemName: 'Loyalty Program Client Tracking',
      lookupItemCode: null,
    },
    generalInquiryActions: {
      lookupItemId: 71857,
      lookupItemName: 'General Inquiry Actions',
      lookupItemCode: null,
    },
  },

  qa: {
    loyaltyProgramClientTracking: {
      lookupItemId: 71856,
      lookupItemName: 'Loyalty Program Client Tracking',
      lookupItemCode: null,
    },
    generalInquiryActions: {
      lookupItemId: 71857,
      lookupItemName: 'General Inquiry Actions',
      lookupItemCode: null,
    },
  },

  staging: {
    loyaltyProgramClientTracking: {
      lookupItemId: 70229,
      lookupItemName: 'Loyalty Program Client Tracking',
      lookupItemCode: null,
    },
    generalInquiryActions: {
      lookupItemId: 70230,
      lookupItemName: 'General Inquiry Actions',
      lookupItemCode: null,
    },
  },

  production: {
    loyaltyProgramClientTracking: {
      lookupItemId: 71856,
      lookupItemName: 'Loyalty Program Client Tracking',
      lookupItemCode: null,
    },
    generalInquiryActions: {
      lookupItemId: 71857,
      lookupItemName: 'General Inquiry Actions',
      lookupItemCode: null,
    },
  },
};

export default ActivityCategory;
